var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_25124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1585 8.67606L19.4073 0.25H17.6895L11.3955 7.56623L6.36842 0.25H0.570312L8.1722 11.3134L0.570312 20.1494H2.28813L8.93482 12.4233L14.2438 20.1494H20.0419L12.1581 8.67606H12.1585ZM9.80575 11.4109L9.03552 10.3092L2.90708 1.54314H5.54554L10.4913 8.61766L11.2615 9.71933L17.6904 18.9151H15.0519L9.80575 11.4113V11.4109Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_25124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.8994,
    height: 19.8994,
    fill: "white",
    transform: "translate(0.357422 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f4372c64931e96b730ee093edd977c53.svg";
export { ForwardRef as ReactComponent };